"use client";
import { StickyNavbar } from "@/components/layout";
import { Earth, Globe } from "@/components/widgets";
import SectionAgents from "@/components/sections/SectionAgents";
import SectionHowitWorks from "@/components/sections/SectionHowItWorks";
import SectionUseCases from "@/components/sections/SectionUseCases";
import Hero from "@/components/sections/Hero";
import { navigationData } from "@/data";
import { v4 as uuidv4 } from "uuid";
import Picture from "@/components/ratl/utility/Picture";
import Image from "next/image";
import mascot from "../../public/ratl/ratl-mascot-1.png";
import ratlBot from "../../public/ratl/ratl-bot-mascot.png";
import CustomButton from "@/components/ratl/utility/CustonButton";
import { useFloat } from "@/lib";
import { useRouter } from "next/navigation";

/* eslint-disable @next/next/no-img-element */
export default function NotFound() {
  const { float, handleFloat } = useFloat([false, false]);
  const router = useRouter();
  return (
    <div className="md:px-[156px] bg-beige px-5 flex flex-col gap-8">
      <div className="md:text-[209px] text-7xl md:w-[560px] mx-auto text-beige-2 font-bold flex gap-[110px] md:gap-[236px] justify-center mt-32 md:mt-56 items-center relative pr-0">
        <h1>4</h1>
        <Image
          width={248}
          height={248}
          className="absolute scale-[1] md:scale-[1.4] z-20 mt-8 md:mt-20"
          src={ratlBot}
          alt="ratl.ai mascot"
          role="img"
          aria-label="ratl.ai mascot"
        />
        <h1 className="">4</h1>
      </div>
      <div className="flex justify-center items-center flex-col mt-4 md:mt-0">
        <h1 className="md:text-[40px] text-3xl text-light-main-heading leading-[120%]">
          Lost in the test lab!
        </h1>
        <p className=" md:text-2xl font-inter text-md text-light-sub-heading leading-[120%]">
          {"Let’s head back to safer ground"}
        </p>
      </div>
      <div className="flex justify-center items-center w-fit mx-auto mb-[7.5rem] z-50">
        <CustomButton
          isStudioBtn={false}
          btnSize={"small"}
          text={"Take me home"}
          animationRequired={false}
          bgType={"solid"}
          showMobile={true}
          controller={float[1]}
          onClick={() => router.push("/")}
          onMouseEnter={() => handleFloat(true, 1)}
          onMouseLeave={() => handleFloat(false, 1)}
          className="px-4 py-2 text-sm transition w-fit rounded-lg border-solid border-[1px] hover:bg-transparent hover:text-black hover:border-solid hover:border-black hover:border-[1px]"
        />
      </div>
    </div>
  );
}
